import React from 'react';
import { FormattedMessage } from 'react-intl';
import { APP_TYPE_HEADERS } from '@constants/individualPortal/dashboard/dashboardModelTypes';
import HistoricalAppInfo from './HistoricalAppInfo';
import HistoricalHouseholdMembers from './HistoricalHouseholdMembers';
import { EligibilityResultsSection } from '@modules/members/historical-applications/components';
import { IHistoricalApplicationViewProps } from '../types/historicalApplication.types';

const HistoricalApplicationView: React.FC<IHistoricalApplicationViewProps> = ({ data }) => {
    const { 
        applicationId,
        applicationYear, 
        submissionDate, 
        primaryContactFirstName, 
        primaryContactLastName, 
        applicants 
    } = data;

    return (
        <article 
            className='gi-panel gi-application-panel application'
            role="region"
            aria-labelledby={`application-heading-${applicationId}`}
            aria-describedby={`application-summary-${applicationId}`}
        >
            <h4 id={`application-heading-${applicationId}`}>
                {applicationYear} <FormattedMessage id={APP_TYPE_HEADERS['OE']}/> <FormattedMessage id='common.application_dated'/> {submissionDate}
            </h4>
            <div id={`application-summary-${applicationId}`}>
                <HistoricalAppInfo data={data} />
            </div>
            <section aria-label="Eligibility Results">
                <EligibilityResultsSection applicants={applicants} />
            </section>
            <section aria-label="Household Members">
                <HistoricalHouseholdMembers
                    applicants={applicants}
                    applicationYear={applicationYear}
                    primaryContactFirstName={primaryContactFirstName}
                    primaryContactLastName={primaryContactLastName}
                />
            </section>
        </article>
    );
};

export default HistoricalApplicationView;
